import { render } from "./reporte_pagos.vue?vue&type=template&id=16e380ec"
import script from "./reporte_pagos.vue?vue&type=script&lang=js"
export * from "./reporte_pagos.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__